import { render } from "./WorkExp.vue?vue&type=template&id=13497c18"
import script from "./WorkExp.vue?vue&type=script&lang=js"
export * from "./WorkExp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__